import styled from 'styled-components'
import { Collapse } from '@mui/material'

export const CustomCollapse = styled(Collapse)`
	min-width: inherit;
	width: 100%;
	z-index: 999;
`
